document.addEventListener('DOMContentLoaded', function () {
  var descEl = document.querySelector('.product__description');
  var accordions = Array.prototype.slice.call(document.querySelectorAll('.product__accordion'));
  if (!descEl && accordions.length === 0) return;

  var anchor = descEl || accordions[0];
  var parent = anchor.parentNode;
  if (!parent) return;

  var items = [];
  if (descEl) {
    items.push({ label: 'Description', html: descEl.innerHTML });
  }
  accordions.forEach(function (acc) {
    var headingEl = acc.querySelector('.accordion__title');
    var contentEl = acc.querySelector('.accordion__content');
    if (!headingEl || !contentEl) return;
    items.push({ label: headingEl.textContent.trim(), html: contentEl.innerHTML });
  });

  if (items.length < 2) return;

  var wrap = document.createElement('div');
  wrap.className = 'khoja-info-tabs';

  var tabRow = document.createElement('div');
  tabRow.className = 'khoja-info-tabs__row';
  tabRow.setAttribute('role', 'tablist');

  var panel = document.createElement('div');
  panel.className = 'khoja-info-tabs__panel rte';
  panel.innerHTML = items[0].html;

  items.forEach(function (item, index) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('role', 'tab');
    btn.className = 'khoja-info-tabs__trigger' + (index === 0 ? ' is-active' : '');
    btn.textContent = item.label;
    btn.addEventListener('click', function () {
      tabRow.querySelectorAll('.khoja-info-tabs__trigger').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      panel.innerHTML = item.html;
    });
    tabRow.appendChild(btn);
  });

  wrap.appendChild(tabRow);
  wrap.appendChild(panel);

  parent.insertBefore(wrap, anchor);

  if (descEl) descEl.remove();
  accordions.forEach(function (acc) {
    acc.remove();
  });
});
